import Modal from "./index";
const IdentityDocumentModal = ({
  showModal,
  setShowModal,
  handleDocumentChange,
  handleDocumentUpload,
  handleChange,
  documentType,
  areFieldsSet,
  isProcessing,
}) => {
  const filteredDocumentType = documentType.filter(function (value) {
    return value.id !== 32;
  });


  return (
    <Modal openModal={showModal} setOpenModal={setShowModal}>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        onClick={() => {
          setShowModal(false);
        }}
      ></button>

      <h2 className="fw-bold text-center mb-1" id="documentModel">
        Upload Document
      </h2>

      <p className="fs-lg text-center text-muted mb-6 mb-md-8">
        Identity Document
      </p>

      <div className="card-body">
        <div className="form-group fallback">
          <div className="custom-file">
            <input
              className="form-control"
              id="documentUpload"
              type="file"
              onChange={handleDocumentChange}
            />
          </div>
        </div>

        <div className="form-group ">
          <label className="form-label" htmlFor="documentType">
            Document Type
          </label>
          <select
            className="form-select"
            id="documentID"
            name="documentName"
            onChange={handleChange}
          >
            <option value="">---select document---</option>
            {filteredDocumentType.map((document) => (
              <option value={document.id} key={document.id}>
                {document.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="documentKey">
            Document Number
          </label>
          <input
            className="form-control"
            id="documentKey"
            type="text"
            required
            onChange={handleChange}
          />
          <div className="invalid-feedback">Please provide document number.</div>
        </div>

        <div className="row">
          <div className="col-12 col-md-auto">
            <button
              className="btn w-100 btn-primary"
              type="submit"
              disabled={!areFieldsSet || isProcessing}
              onClick={handleDocumentUpload}
            >
              {isProcessing ? <>Saving ...</> : <>Save Document</>}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IdentityDocumentModal;
